const getMedia = () => {
  const isMobile = window.innerWidth < 768;
  const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
  return isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
};

export default getMedia;
